var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"element element--loader"},[_c('label',{staticClass:"element__label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"element__loader"}),_c('ElementSubIcon',{attrs:{"name":"loader"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }